export const LANG_LABELS: Record<string, string> = {
  fr: 'Français',
  en: 'English',
  de: 'Deutsch',
  es: 'Español',
  it: 'Italiano',
  pt: 'Português',
  nl: 'Nederlands',
};

/** UI languages selectable for now; others stay listed but disabled. */
export const ENABLED_UI_LANGS = new Set(['fr', 'en']);

export function getLangLabel(code: string): string {
  return LANG_LABELS[code] ?? code.toUpperCase();
}

export function isUiLangEnabled(code: string): boolean {
  return ENABLED_UI_LANGS.has((code || '').toLowerCase());
}
